module.exports = __webpack_public_path__ + "img/twitter-icon.f0e7c25e.svg";